import log from 'chameleon/ui-stack/utilities/log';

/**
 * questionId {string} The question id for container detection
 * questionParts {array} The question parts
 * */
export const getPartByDomQuestion = (questionId, questionParts) => {
  let part;
  try {
    const questionContainer = document.querySelector(
      `#scoring-block-${questionId}`,
    );
    const currentPartContainer = questionContainer.querySelector(
      '.content-item:not([hidden]) .learnosity-item.lrn.lrn-item-processed',
    );
    const currentRubricReference = currentPartContainer.dataset.reference;
    part = (questionParts || []).find(
      ({ learnosityItemReference }) =>
        learnosityItemReference === currentRubricReference,
    );
  } catch (error) {
    log('error', error);
  }

  return part;
};
